import { Tabs } from 'antd';
import { log } from 'utils';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchConfigs, setActiveTab } from 'state/actions/configuration';
import { fetchWebContents } from 'state/actions/webContents';
import { fetchWebPages } from 'state/actions/webPages';
import { fetchWebLayout } from 'state/actions/webLayout';
import { fetchWebMenus } from 'state/actions/webMenus';
import './Configuration.css';

// menu icons
import PostIcon from '../../assets/icon/menuConfiguration/post.png';
import PageIcon from '../../assets/icon/menuConfiguration/pages.png';
import MenuIcon from '../../assets/icon/menuConfiguration/menu.png';

import PostingPage from './PostingPage';
import WebPagesPage from './WebPagesPage';
import WebMenusPage from './WebMenusPage';
import WebLayoutConfigPage from './WebLayoutConfigPage';

const { TabPane } = Tabs;

// `access` is the role's access entry for this site; superadmin passes none and sees every tab.
function Configuration({ access }) {
  const dispatch = useDispatch();
  const { loading, configData, userData } = useSelector(
    (state) => ({
      loading: state.config.loading,
      configData: state.configuration.config,
      userData: state.auth.userData,
    }),
    shallowEqual
  );

  const { tab: activeTab } = useSelector((state) => ({
    tab: state.configuration.tab,
  }));

  const { siteId } = useParams();
  const [configPages, setConfigPages] = useState();

  useEffect(() => {
    dispatch(fetchConfigs({ siteId }));
  }, [siteId, dispatch]);

  const canRead = (module) => {
    if (!access) return true;
    return Boolean(access[module] && access[module].read);
  };

  useEffect(() => {
    const newConf = [
      {
        key: 'post',
        title: 'Post',
        active: canRead('post'),
        completeParams: ['Post'],
        image: PostIcon,
        children: <PostingPage loading={loading} userData={userData} />,
      },
      {
        key: 'pages',
        title: 'Pages',
        active: canRead('pages'),
        completeParams: ['pages'],
        image: PageIcon,
        children: <WebPagesPage error={'error'} />,
      },
      {
        key: 'layout-config',
        title: 'Layout Config',
        active: canRead('layoutConfig'),
        completeParams: ['layout-config'],
        image: MenuIcon,
        children: <WebLayoutConfigPage loading={loading} userData={userData} />,
      },
      {
        key: 'menu',
        title: 'Menu',
        active: canRead('menu'),
        completeParams: ['menu'],
        image: MenuIcon,
        children: <WebMenusPage loading={loading} userData={userData} />,
      },
    ];
    setConfigPages(newConf);
  }, [configData, access]); // eslint-disable-line

  const handleChangeTab = (activeKey) => {
    log(activeKey);
    dispatch(setActiveTab(activeKey));
    switch (activeKey) {
      case 'post':
        dispatch(fetchWebContents({ siteId }));
        break;
      case 'pages':
        dispatch(fetchWebPages({ siteId }));
        break;
      case 'layout-config':
        dispatch(fetchWebLayout({ siteId }));
        break;
      case 'menu':
        dispatch(fetchWebMenus({ siteId }));
        break;
      default:
        break;
    }
  };

  return (
    <div className="configuration">
      <Tabs
        activeKey={activeTab}
        onTabClick={handleChangeTab}
        className="config-tab"
        tabPosition="left"
      >
        {configPages &&
          configPages.map(
            (page) =>
              page.active && (
                <TabPane
                  tab={
                    <div
                      onClick={(e) => e.preventDefault()}
                      className="configuration-nav"
                    >
                      <img src={page.image} className="menuIcon" alt={page.title} />
                      <span>{page.title}</span>
                    </div>
                  }
                  style={{
                    paddingLeft: '0px',
                  }}
                  key={page.key}
                >
                  {page.children}
                </TabPane>
              )
          )}
      </Tabs>
    </div>
  );
}

export default Configuration;
